/**
 * CFO Dashboard Export Utilities
 * Generates CSV downloads from KPI and chart data.
 */

interface KPIExportRow {
  label: string;
  value: string;
  change?: number;
  status?: string;
}

interface MonthlyDataRow {
  month: string;
  revenue: number;
  expenses: number;
  netCashFlow: number;
}

/**
 * Generate CSV string from KPI data.
 */
export function generateKPICSV(kpis: KPIExportRow[]): string {
  const header = "Metric,Value,Change (%),Status\n";
  const rows = kpis.map(
    k =>
      `"${escapeCSV(k.label)}","${escapeCSV(k.value)}",${k.change ?? ""},${k.status ?? ""}`
  );
  return header + rows.join("\n") + "\n";
}

/**
 * Generate CSV string from monthly chart data.
 */
export function generateMonthlyCashFlowCSV(data: MonthlyDataRow[]): string {
  const header = "Month,Revenue (CHF),Expenses (CHF),Net Cash Flow (CHF)\n";
  const rows = data.map(
    d => `${d.month},${d.revenue},${d.expenses},${d.netCashFlow}`
  );
  return header + rows.join("\n") + "\n";
}

/**
 * Trigger a CSV file download in the browser.
 */
export function downloadCSV(csv: string, filename: string) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

function escapeCSV(str: string): string {
  return str.replace(/"/g, '""');
}
